import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_router_view = _resolveComponent("router-view")

  return (_ctx.validatingEntrance)
    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}